"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewProduct = exports.removeProduct = exports.addProduct = void 0;
var constants_1 = require("../constants");
var getActionableProps = function (_a) {
    var _b;
    var product = _a.product, session = _a.session;
    return (_b = {},
        _b[constants_1.EventProperty.ACTION_SCREEN] = product.screen,
        _b[constants_1.EventProperty.CUSTOMER_NAME] = session.customer,
        _b[constants_1.EventProperty.ORDER_NOTE] = product.note,
        _b[constants_1.EventProperty.PRODUCT_CATEGORY] = product.category,
        _b[constants_1.EventProperty.PRODUCT_ID] = product.id,
        _b[constants_1.EventProperty.PRODUCT_NAME] = product.name,
        _b[constants_1.EventProperty.PRODUCT_PRICE] = product.price,
        _b[constants_1.EventProperty.PRODUCT_SKU] = product.sku,
        _b[constants_1.EventProperty.USER_ID] = session.userID,
        _b);
};
exports.addProduct = function (_a) {
    var product = _a.product, session = _a.session;
    var props = getActionableProps({ product: product, session: session });
    window.analytics.track(constants_1.EventName.PRODUCT_ADDED, props);
};
exports.removeProduct = function (_a) {
    var product = _a.product, session = _a.session;
    var props = getActionableProps({ product: product, session: session });
    window.analytics.track(constants_1.EventName.PRODUCT_REMOVED, props);
};
var getViewableProps = function (_a) {
    var product = _a.product, session = _a.session;
    var _b = getActionableProps({
        product: { ...product, note: '' },
        session: session,
    }), _c = constants_1.EventProperty.ORDER_NOTE, note = _b[_c], viewableProps = __rest(_b, [typeof _c === "symbol" ? _c : _c + ""]);
    return viewableProps;
};
exports.viewProduct = function (_a) {
    var product = _a.product, session = _a.session;
    var props = getViewableProps({ product: product, session: session });
    console.log('props', props);
    window.analytics.track(constants_1.EventName.PRODUCT_VIEWED, props);
};
